/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 2/22/16.
 */

'use strict';

angular.module('prism-ui.package').service('PackageActionService', function (
    _,
    $q,
    $route,
    $timeout,
    loginService,
    ClipResourceFactory,
    DownloadAssetService,
    DynamicPropertiesService,
    EndPointService,
    ModalService,
    NavbarUtilService,
    NotificationService,
    orderByFilter,
    PackageMediaResourceFactory,
    PackageResourceFactory,
    PackageService,
    PackageMediaService,
    PackageUtilService,
    PartnerPackagesService,
    PartnerResourceFactory,
    PermissionsResourceFactory,
    PermissionsService,
    UtilsService,
    ReportViewService,
    WorkflowExecutionResourceFactory,
    WorkflowService
) {
    let self = this;

    let BATCH_MODIFY_METADATA_WORKFLOW_KEY = 'batchModifyPackageMetadata';
    let DOWNLOAD_PROXIES_WORKFLOW_KEY = 'downloadProxies';
    let EXPORT_DELIVERY_REPORT_WORKFLOW_KEY = 'exportDeliveryReport';
    let EXPORT_METADATA_WORKFLOW_KEY = 'exportMetadataReport';
    let PACKAGEDELIVERY_SELECTPACKAGES_WORKFLOW_KEY = 'mainPartnerDeliveryWorkflow';
    let REMOVE_PACKAGE_MEDIA_WORKFLOW_KEY = 'removePackageMedia';
    let RESET_SELECTED_CLIP_PACKAGE_WORKFLOW_KEY = 'resetSelectedClipPackages';
    let RESET_SELECTED_PACKAGES_WORKFLOW_KEY = 'resetSelectedPackages';
    let RETRIEVE_MASTER_MEDIA_WORKFLOW_KEY = 'retrievePackageMedia';
    let VALIDATE_SELECTED_PACKAGES_WORKFLOW_KEY = 'validateSelectedPackages';

    self.clipPermissions = {
        hasPermissions: false,
        validatePermissions: [],
        deliverClipPermissions: [],
        retrieveClipMediaPermission: [],
        clipBatchModifyPermission: [],
        clipMetadataReportPermission: [],
        clipResetPermissions: [],
        clipDeliveryReportPermission: []
    };

    self.actionsLoading = false;

    //
    // 2018-Jan-3
    //
    // ABC-9317 - The "Batch Modify Metadata" action will function
    //      the same but will be renamed to "Check Out Package(s)"
    //
    self.BATCH_MODIFY_METADATA_ACTION = {
        label: 'Check Out Package(s)',
        workflowKey: BATCH_MODIFY_METADATA_WORKFLOW_KEY,
        disabled: true
    };

    self.DELIVER_PACKAGE_SELECT_PARTNERS_ACTION = {
        label: 'Deliver Package(s) - Select Partners',
        workflowKey: PACKAGEDELIVERY_SELECTPACKAGES_WORKFLOW_KEY,
        disabled: true
    };

    self.DELIVERY_REPORT_ACTION = {
        label: 'Execute Delivery Report',
        workflowKey: EXPORT_DELIVERY_REPORT_WORKFLOW_KEY,
        disabled: true
    };

    self.DOWNLOAD_PROXIES_ACTION = {
        label: 'Download Video Proxies',
        workflowKey: DOWNLOAD_PROXIES_WORKFLOW_KEY,
        disabled: true
    };

    self.EXPORT_METADATA_REPORT_ACTION = {
        label: 'Export ALL Metadata',
        workflowKey: EXPORT_METADATA_WORKFLOW_KEY,
        disabled: true
    };

    self.REMOVE_PACKAGE_MEDIA_ACTION = {
        label: 'Remove Package Media',
        workflowKey: REMOVE_PACKAGE_MEDIA_WORKFLOW_KEY,
        disabled: true
    };

    self.RESET_CLIP_PACKAGE_ACTION = {
        label: 'Reset Clip Package',
        workflowKey: RESET_SELECTED_CLIP_PACKAGE_WORKFLOW_KEY,
        disabled: true
    };

    self.RESET_PACKAGE_ACTION = {
        label: 'Reset Package',
        workflowKey: RESET_SELECTED_PACKAGES_WORKFLOW_KEY,
        disabled: true
    };

    self.RETRIEVE_MASTER_MEDIA_ACTION = {
        label: 'Retrieve Master Media',
        workflowKey: RETRIEVE_MASTER_MEDIA_WORKFLOW_KEY,
        disabled: true
    };

    self.VALIDATE_PACKAGE_ACTION = {
        label: 'Validate Package(s)',
        workflowKey: VALIDATE_SELECTED_PACKAGES_WORKFLOW_KEY,
        disabled: true
    };

    DynamicPropertiesService.queryForProperties().then(() => {
        self.redeliveryReasons = DynamicPropertiesService.getPropValueAsList('package.redeliveryReasons');
    });

    self.actions = [
        self.BATCH_MODIFY_METADATA_ACTION,
        self.DELIVER_PACKAGE_SELECT_PARTNERS_ACTION,
        self.DOWNLOAD_PROXIES_ACTION,
        self.RESET_PACKAGE_ACTION,
        self.RETRIEVE_MASTER_MEDIA_ACTION,
        self.VALIDATE_PACKAGE_ACTION
    ];

    self.editorActions = [
        self.DELIVER_PACKAGE_SELECT_PARTNERS_ACTION,
        self.REMOVE_PACKAGE_MEDIA_ACTION,
        self.RESET_PACKAGE_ACTION,
        self.RETRIEVE_MASTER_MEDIA_ACTION
    ];

    self.liveClipActions = [
        self.BATCH_MODIFY_METADATA_ACTION,
        self.DELIVER_PACKAGE_SELECT_PARTNERS_ACTION,
        self.DELIVERY_REPORT_ACTION,
        self.EXPORT_METADATA_REPORT_ACTION,
        self.RESET_CLIP_PACKAGE_ACTION,
        self.RETRIEVE_MASTER_MEDIA_ACTION,
        self.VALIDATE_PACKAGE_ACTION
    ];

    self.liveClipEditorActions = [
        self.DELIVER_PACKAGE_SELECT_PARTNERS_ACTION,
        self.RESET_CLIP_PACKAGE_ACTION,
        self.RETRIEVE_MASTER_MEDIA_ACTION,
        self.VALIDATE_PACKAGE_ACTION
    ];

    self.selectedPackages = [];
    self.partnerMap = {};
    self.availableDeliveryTemplatesForPartners = {};
    self.partners = [];

    var resetActionsToDisabled = function () {
        _.forEach(self.actions, function (action) {
            action.disabled = true;
        });
    };

    var resetClipActionsToDisabled = function () {
        _.forEach(self.liveClipActions, function (action) {
            action.disabled = true;
        });
    };

    const hasValidPackage = (partnerPackage) => {
        return !_.get(partnerPackage, 'validationResult.errors.length');
    };

    const setValidationErrorsAndWarnings = (parentPackage, partnerPackage, partnerMapObj) => {
        var mappedErrors = partnerPackage.validationResult.errors.map(function (error) {
            return {type: 'error', label: `${error.description} - ${parentPackage.name}`};
        });
        var mappedWarnings = partnerPackage.validationResult.warnings.map(function (warning) {
            return {type: 'warning', label: `${warning.description} - ${parentPackage.name}`};
        });
        Array.prototype.push.apply(partnerMapObj.partnerPkgErrors, mappedErrors);
        Array.prototype.push.apply(partnerMapObj.partnerPkgWarnings, mappedWarnings);
    };

    let partnerArraysMap = {};

    const setPartnerMapValidations = (partnerPackage, partnerMapObj, parentPackage, partnerPromises) => {

        // Is the partner package enabled?
        if (partnerPackage.enabled) {

            // Add to list of partners
            self.partners.push(partnerPackage.partner);

            if (_.toNumber(partnerPackage.partner.numberOfChildren) > 0) {

                const childPartnerPromise = PartnerResourceFactory.getChildren({id: partnerPackage.partner.id})
                    .$promise.then((childPartners) => {

                        const sortIteratee = (partner) => partner.name.toLowerCase();
                        _.chain(childPartners)
                            .orderBy(sortIteratee)
                            .sortedUniqBy(sortIteratee)
                            .value();

                        partnerArraysMap[childPartners[0].parentId] = childPartners;

                        _.forEach(childPartners, (childPartner) => {
                            if (!self.partnerMap[childPartner.id]) {
                                self.partnerMap[childPartner.id] = {
                                    partner: childPartner,
                                    partnerPkgErrors: [],
                                    partnerPkgWarnings: [],
                                    deliveryTemplates: childPartner.deliveryTemplates,
                                    redeliver: false,
                                    packageIds: [],
                                    partnerPackageInfoLookup: {}
                                };
                            }

                            self.partnerMap[childPartner.id].partnerPackageInfoLookup[partnerPackage.id] = {
                                partnerPackage: partnerPackage,
                                package: parentPackage
                            };
                            self.partnerMap[childPartner.id].packageIds.push(parentPackage.id);
                            self.partnerMap[childPartner.id].hasValidPackage = hasValidPackage(partnerPackage);

                            // Add errors & warnings for package to partner
                            if (partnerPackage.validationResult) {
                                setValidationErrorsAndWarnings(parentPackage, partnerPackage, self.partnerMap[childPartner.id]);
                            }
                        });
                    }
                );

                partnerPromises.push(childPartnerPromise);
            }

            // Add instance label to partner package partner
            if (partnerPackage.partner.partnerDeliveryInstanceEnabled) {
                var selectedInstance = PartnerPackagesService.getSelectedInstance(partnerPackage);
                if (!selectedInstance) {
                    selectedInstance = partnerPackage.deliveryInstances[partnerPackage.deliveryInstances.length - 1];
                }
                partnerPackage.partner.deliveryLabel = 'Instance ' +
                    selectedInstance.instance + '.' + selectedInstance.revision;
            }
        } else {
            // Create artificial error for being disabled
            partnerMapObj.partnerPkgErrors.push({
                type: 'error',
                label: `De-selected partner - ${parentPackage.name}`
            });
        }

        // Partner has valid package if there's no errors
        partnerMapObj.hasValidPackage = hasValidPackage(partnerPackage);

        // Add errors & warnings for package to partner
        if (partnerPackage.validationResult) {
            setValidationErrorsAndWarnings(parentPackage, partnerPackage, partnerMapObj);
        }
    };

    const handleNewPartnerMapObj = (partnerPackage) => {
        // Create partner map entry
        self.partnerMap[partnerPackage.partner.id] = {
            partner: partnerPackage.partner,
            partnerPackageInfoLookup: {},
            partnerPkgErrors: [],
            partnerPkgWarnings: [],
            deliveryTemplates: [],
            redeliver: parseInt(partnerPackage.revision) > 1,
            packageIds: []
        };

        // Add partner delivery template list
        return PartnerResourceFactory.get({id: partnerPackage.partner.id}).$promise.then((partner) => {
            self.partnerMap[partnerPackage.partner.id].deliveryTemplates = partner.deliveryTemplates;
        });
    };

    const setupPartnerMap = (parentPackage, partnerPkgs) => {
        let partnerPromises = [];

        // Populate partner map
        _.forEach(partnerPkgs, (partnerPackage) => {
            let partnerMapObj = self.partnerMap[partnerPackage.partner.id];
            if (!partnerMapObj) {
                partnerPromises.push(handleNewPartnerMapObj(partnerPackage));

                partnerMapObj = self.partnerMap[partnerPackage.partner.id];
            } else {
                if (!partnerMapObj.redeliver) {
                    // ... shouldn't this be an or-equals?
                    partnerMapObj.redeliver = parseInt(partnerPackage.revision) > 1;
                }
            }

            // Add main package ID to partner's list of packages
            partnerMapObj.partnerPackageInfoLookup[partnerPackage.id] = {
                package: parentPackage,
                partnerPackage: partnerPackage
            };
            partnerMapObj.packageIds.push(parentPackage.id);

            // Add validation info to partner
            setPartnerMapValidations(partnerPackage, partnerMapObj, parentPackage, partnerPromises);
        });

        partnerArraysMap = _.chain(self.partnerMap)
            .cloneDeep(self.partnerMap)
            .mapValues(() => [])
            .value();

        partnerArraysMap.partners = [];

        return $q.all(partnerPromises);
    };

    var callNavbarViewSearchFunction = function () {
        if (NavbarUtilService.viewSearchFunction) {
            NavbarUtilService.viewSearchFunction();
        } else if (PackageUtilService.tabLoadDataFunction) {
            PackageUtilService.tabLoadDataFunction();
        }
    };

    var setupWorkflowPromises = function (workflowPromises) {
        //
        // This collects all workflow promises into one promise.
        //
        // Subsequent to that one promise, display relevant
        // notifications and reset the view.
        //

        return $q.all(workflowPromises)
            .then(function (workflowPromises) {
                NotificationService.createInfoNotification(
                    workflowPromises.length + ((workflowPromises.length > 1)?
                        ' packages':
                        ' package') +
                    ' sent to workflow');
            })
            .catch(function (failure) {
                if (failure && failure.statusText && failure.statusText.indexOf('already being delivered.') > -1) {
                    NotificationService.createFailureNotification(
                        failure.statusText,
                        '',
                        true);
                } else {
                    NotificationService.createFailureNotification(
                        'One or more of the workflows failed to start.',
                        '',
                        true);
                }
            })
            .finally(function () {
                callNavbarViewSearchFunction();

                //
                // ABC-8725 - Duplicate delivery workflows
                //
                // This is the end of the line after a user sends
                // a workflow to delivery.
                //
                // So now we're going to destroy everything that
                // was used to create the call that initiates the
                // workflow.
                //
                // We also attempt to lock the dist. grid ASAP by
                // giving the server 2 seconds to change the
                // package's status and then polling for status
                // updates.
                //

                $timeout(function () {
                    PackageUtilService.pollForPackageUpdates();
                }, 2000);

                self.partnerMap = {};
                self.availableDeliveryTemplatesForPartners = {};
                self.partners = [];

                _.forEach(workflowPromises, function (workflowPromise, index) {
                    _.forEach(_.keys(workflowPromise), function (key) {
                        delete workflowPromise[key];
                        workflowPromises[index] = null;

                        // ... is it dead yet?
                    });
                });
            });
    };

    var packageHasPartnerSelected = function (pkg, partnerId) {
        var foundDeselectedError = self.partnerMap[partnerId].partnerPkgErrors.filter(function (pkgError) {
            return pkgError.label === 'De-selected partner - ' + pkg.name;
        });
        return foundDeselectedError.length === 0;
    };

    const startDeliveryWorkflow = (selectedPackage, redeliveryReason, partnerDeliveryTemplates) => {
        let deliveryWorkflowPromise = null;
        if (partnerDeliveryTemplates.length > 0) {
            deliveryWorkflowPromise = WorkflowExecutionResourceFactory.startInstanceDelivery({
                packageId: selectedPackage.id,
                redeliveryReason: redeliveryReason,
            }, partnerDeliveryTemplates);
        }
        return deliveryWorkflowPromise;
    };

    const createDeliveryWorkflowTemplateData = (selectedPackage, partnerMapItem, partnerDeliveryInstanceId=null) => {
        let template = _.cloneDeep(partnerMapItem.template);

        if (partnerDeliveryInstanceId) {
            template.partnerDeliveryInstanceId = partnerDeliveryInstanceId;
        }

        if (template.template.custom) {
            let deliveryItemIds = [];
            _.forEach(template.partnerDeliveryItemIds, (deliveryItemMSDId) => {
                let encodedId = _.split(deliveryItemMSDId, '_');
                let packageId = encodedId[0];
                let deliveryItemId = encodedId[1];
                if (packageId === selectedPackage.id) {
                    deliveryItemIds.push(deliveryItemId);
                }
            });
            if (deliveryItemIds.length > 0) {
                template.partnerDeliveryItemIds = deliveryItemIds;
            } else {
                delete template.partnerDeliveryItemIds;
                template = null;
            }
        }

        return template;
    };

    const createDeliveryPromise = (selectedPackage, modalValues) => {
        let selectedInstance = {};

        if (selectedPackage.id === PartnerPackagesService.parentPackageId()) {
            _.forEach(PartnerPackagesService.partnerPackages(), (partnerPackage) => {
                let selectedInstanceMap = PartnerPackagesService.selectedInstanceMap();
                selectedInstance[partnerPackage.partner.id] = selectedInstanceMap[partnerPackage.id];
            });
        }

        let partnerDeliveryTemplates = [];
        _.forEach(modalValues.selectedPartners, (partnerMapItem, partnerId) => {
            if (_.includes(self.partnerMap[partnerId].packageIds, selectedPackage.id) &&
                packageHasPartnerSelected(selectedPackage, partnerId))
            {
                let template = createDeliveryWorkflowTemplateData(
                    selectedPackage,
                    partnerMapItem,
                    _.get(selectedInstance, partnerId, null)
                );

                if (template) {
                    partnerDeliveryTemplates.push(template);
                }
            }
        });

        return startDeliveryWorkflow(selectedPackage, modalValues.redeliveryReason, partnerDeliveryTemplates);
    };

    self.handlePartnerDelivery = (modalValues) => {
        var workflowPromises = [];
        _.forEach(self.selectedPackages, (selectedPackage) => {
            let deliveryPromise = createDeliveryPromise(selectedPackage, modalValues);
            if (deliveryPromise) {
                workflowPromises.push(deliveryPromise);
            }
        });
        setupWorkflowPromises(workflowPromises);
    };

    var setInvalidPartnerErrors = function () {
        _.forEach(self.partners, function (partner) {
            _.forEach(self.selectedPackages, function (pkg) {
                if (self.partnerMap[partner.id].packageIds.indexOf(pkg.id) === -1) {
                    self.partnerMap[partner.id].partnerPkgErrors.push({
                        type: 'error',
                        label: 'Invalid Partner for Package - ' + pkg.name
                    });
                }
            });
        });
    };

    const setPartnerRedeliverFlag = () => {
        let deliveryPromises = [];

        _.forEach(self.selectedPackages, (selectedPackage) => {
            let completedDeliveriesPromise = PackageService.getCompletedDeliveries(selectedPackage, true).then((completedDeliveries) => {
                _.forEach(completedDeliveries, (delivery) => {
                    _.forEach(self.partnerMap, (partnerMapContainer) => {
                        if (partnerMapContainer.partner.name === delivery.partnerName) {
                            partnerMapContainer.redeliver = true;
                        }
                    });
                });
            });

            deliveryPromises.push(completedDeliveriesPromise);
        });

        return $q.all(deliveryPromises);
    };

    const showPackageDeliveryModal = () => {
        self.partnerMap = {};
        self.availableDeliveryTemplatesForPartners = {};
        self.partners = [];
        let partnerPkgsQueries = [];
        let partnerSetupPromises = [];

        _.forEach(self.selectedPackages, (selectedPkg) => {

            let partnerPkgQuery = PartnerPackagesService.getPartnerPackagesForValidation(selectedPkg.id).then((partnerPkgs) => {
                let partnerSetupPromise = setupPartnerMap(selectedPkg, partnerPkgs);
                partnerSetupPromises.push(partnerSetupPromise);

                return partnerSetupPromises;
            });

            partnerPkgsQueries.push(partnerPkgQuery);
        });

        return $q.all(partnerPkgsQueries).then(() => {
            return $q.all(partnerSetupPromises).then(() => {

                let sortIteratee = (partner) => partner.name.toLowerCase();

                _.chain(self.partners)
                    .orderBy(sortIteratee)
                    .sortedUniqBy(sortIteratee)
                    .forEach((partner) => {
                        partnerArraysMap[partner.id].unshift(partner);
                        partnerArraysMap.partners = partnerArraysMap.partners.concat(partnerArraysMap[partner.id]);
                    })
                    .value();

                self.partners = partnerArraysMap.partners;

                setInvalidPartnerErrors();

                setPartnerRedeliverFlag().then(() => {
                    ModalService.showSelectDeliveryPartnersModal(self.handlePartnerDelivery);
                });
            });
        });
    };

    var validatePackages = function () {
        var packageIds = self.selectedPackages.map(function (pkg) {
            return '' + pkg.id;
        });
        return PackageResourceFactory.validatePackages(packageIds).$promise.then(callNavbarViewSearchFunction);
    };

    var resetPackages = function () {
        var pkgIds = self.selectedPackages.map(function (pkg) {
            return pkg.id;
        });
        return PackageResourceFactory.resetPackages(pkgIds).$promise.then(callNavbarViewSearchFunction);
    };

    var removePackageMedia = function (showLoadingIndicator, hideLoadingIndicator) {
        var pkg = _.first(self.selectedPackages);
        showLoadingIndicator();

        delete pkg.primaryAcceptTemplateMember;
        delete pkg.primaryVideo;
        delete pkg.primaryImage;
        delete pkg.mediaRevision;
        delete pkg.mediaVersion;
        delete pkg.fourByThreeSafe;
        delete pkg.endCreditTimecode;

        return PackageResourceFactory.save({id: pkg.id}, pkg).$promise
            .then(function () {
                return PackageMediaResourceFactory.save({
                    id: pkg.id,
                    pendingIngest: true
                }, [ /* Empty media asset array to clear package media assets */ ]).$promise;
            }).then(function () {
                $route.reload();
            }).finally(hideLoadingIndicator);
    };

    var confirmRemovePackageMedia = function (showLoadingIndicator, hideLoadingIndicator) {
        ModalService.showMessageModal(
            {
                messageText: `Are you sure you want to remove all package assets? This cannot be undone.`,
                pullCancelLeft: true,
                title: 'Reset Package Media',
                windowClass: 'confirm-modal-lg',
                showOK: true
            },
            function() {
                removePackageMedia(showLoadingIndicator, hideLoadingIndicator);
            });
        return $q.when(false);
    };

    let downloadPackageProxies = () => {
        _.forEach(self.selectedPackages, (packageObject) => {
            let assetId = packageObject.primaryVideo.assetId;
            let proxyFileName = PackageMediaService.generatePackageDownloadFilenamePrefix(packageObject, false) +
                'video_proxy.' + UtilsService.getFileExtension(packageObject.primaryVideo.proxyPath);

            DownloadAssetService.downloadAsset(assetId, proxyFileName, DownloadAssetService.AssetType.Video, DownloadAssetService.ContentUse.Proxy);
        });

        // each of these handlers is expected to return a promise
        return $q.when(true);
    };

    var resetClipPackages = function () {
        var resetPromises = [];
        _.forEach(self.selectedPackages, function (selectedPackage) {
            resetPromises.push(ClipResourceFactory.resetClip({id: selectedPackage.id}).$promise);
        });
        return $q.all(resetPromises).then(callNavbarViewSearchFunction);
    };

    var handleGenerateBatchMetadataReport = function (reportOptions) {
        ReportViewService.PACKAGE_BATCH_MODIFY_REPORT.formTitle = '';
        reportOptions.selectedPackages = self.selectedPackages;
        ReportViewService.startReportWorkflow(ReportViewService.PACKAGE_BATCH_MODIFY_REPORT, reportOptions);
    };

    var showBatchMetadataReportModal = function () {
        ReportViewService.PACKAGE_BATCH_MODIFY_REPORT.formTitle = 'Create a package report that will lock ' +
            self.selectedPackages.length + ' package' + (self.selectedPackages.length > 1 ? 's': '') +' for batch modification';
        ModalService.showCreateReportModal(ReportViewService.PACKAGE_BATCH_MODIFY_REPORT, handleGenerateBatchMetadataReport);
        return $q.when(true);
    };

    var handleSelectedMasterMediaContent = function (selectedContentTypes) {
        var mediaTypes = [], workflowPromises = [];
        _.forEach(selectedContentTypes, function (contentType, key) {
            mediaTypes.push(key);
        });
        _.forEach(self.selectedPackages, function (pkg) {
            var workflowParameters = {
                subject: '[Package.' + pkg.id + ']',
                mediaTypes: mediaTypes
            };
            workflowPromises.push(
                WorkflowService.startWorkflow(
                    RETRIEVE_MASTER_MEDIA_WORKFLOW_KEY,
                    workflowParameters)
            );
        });
        setupWorkflowPromises(workflowPromises);
    };

    var showSelectMasterMediaTypesModal = function () {
        ModalService.showSelectMasterMediaTypesModal(handleSelectedMasterMediaContent);
        return $q.when(true);
    };

    var showPackageMetadataReportModal = function () {
        ModalService.showCreateReportModal(ReportViewService.CLIP_PACKAGE_ALL_METADATA_REPORT, function (reportOptions) {
            reportOptions.selectedPackages = self.selectedPackages;
            ReportViewService.startReportWorkflow(ReportViewService.CLIP_PACKAGE_ALL_METADATA_REPORT, reportOptions);
        });
        return $q.when(true);
    };

    var showPackageDeliveryReportModal = function () {
        ModalService.showCreateReportModal(ReportViewService.CLIP_PACKAGE_DELIVERY_REPORT, function (reportOptions) {
            reportOptions.selectedPackages = self.selectedPackages;
            reportOptions.includeMasterPkgs = false;
            reportOptions.includeClipToolPkgs = true;
            ReportViewService.startReportWorkflow(ReportViewService.CLIP_PACKAGE_DELIVERY_REPORT, reportOptions);
        });
        return $q.when(true);
    };

    self.handleSelectedAction = function (selectedAction, showLoadingIndicator, hideLoadingIndicator) {
        var actionPromise = $q.when(true);
        showLoadingIndicator();

        switch (selectedAction.workflowKey) {
            case BATCH_MODIFY_METADATA_WORKFLOW_KEY:
                actionPromise = showBatchMetadataReportModal();
                break;
            case DOWNLOAD_PROXIES_WORKFLOW_KEY:
                actionPromise = downloadPackageProxies();
                break;
            case EXPORT_DELIVERY_REPORT_WORKFLOW_KEY:
                actionPromise = showPackageDeliveryReportModal();
                break;
            case EXPORT_METADATA_WORKFLOW_KEY:
                actionPromise = showPackageMetadataReportModal();
                break;
            case PACKAGEDELIVERY_SELECTPACKAGES_WORKFLOW_KEY:
                actionPromise = showPackageDeliveryModal();
                break;
            case REMOVE_PACKAGE_MEDIA_WORKFLOW_KEY:
                actionPromise = confirmRemovePackageMedia(showLoadingIndicator, hideLoadingIndicator);
                break;
            case RESET_SELECTED_CLIP_PACKAGE_WORKFLOW_KEY:
                actionPromise = resetClipPackages();
                break;
            case RESET_SELECTED_PACKAGES_WORKFLOW_KEY:
                actionPromise = resetPackages();
                break;
            case RETRIEVE_MASTER_MEDIA_WORKFLOW_KEY:
                actionPromise = showSelectMasterMediaTypesModal();
                break;
            case VALIDATE_SELECTED_PACKAGES_WORKFLOW_KEY:
                actionPromise = validatePackages();
        }

        return actionPromise.then(hideLoadingIndicator);
    };


    //========================================//
    // Package / Clip Action Enable & Disable //
    //========================================//

    var canValidateClip = function (pkg) {
        return PermissionsService.canWritePackage('CLIP_ACTION_VALIDATE_VIEW_STATE', pkg.id);
    };

    var allClipsCanBeValidated = function (validatePermissions) {
        var allClipsCanBeValidated = validatePermissions.length > 0;
        return $q.all(validatePermissions).then(function (clipsCanBeValidated){
            _.forEach(clipsCanBeValidated, function (clipCanBeValidated) {
                allClipsCanBeValidated = allClipsCanBeValidated && clipCanBeValidated;
            });
            self.VALIDATE_PACKAGE_ACTION.disabled = !allClipsCanBeValidated;
            return !allClipsCanBeValidated;
        });
    };

    var canResetClip = function (pkg) {
        if (self.selectedPackages.length === 1) {
            return PermissionsService.canWritePackage('CLIP_ACTION_RESET_VIEW_STATE', pkg.id);
        }
    };

    var allClipsCanBeReset = function (clipResetPermissions) {
        var allClipsCanBeReset = clipResetPermissions.length > 0;
        return $q.all(clipResetPermissions).then(function (clipsCanBeReset) {
            _.forEach(clipsCanBeReset, function (clipCanBeReset) {
                allClipsCanBeReset = allClipsCanBeReset && clipCanBeReset;
            });
            self.RESET_CLIP_PACKAGE_ACTION.disabled = !allClipsCanBeReset;
            return !allClipsCanBeReset;
        });
    };

    var allPackagesCanBeDelivered = function (deliveryPermissions) {
        var allPackagesCanBeDelivered = deliveryPermissions.length > 0;
        return $q.all(deliveryPermissions).then(function (pkgsCanBeDelivered) {
            _.forEach(pkgsCanBeDelivered, function (pkgCanBeDelivered) {
                allPackagesCanBeDelivered = allPackagesCanBeDelivered && pkgCanBeDelivered;
            });

            let actionLabelTextAppend = ' - Select Partners';
            self.DELIVER_PACKAGE_SELECT_PARTNERS_ACTION.label = (deliveryPermissions.length > 1) ?
                `Deliver Package(s) ${actionLabelTextAppend}` :
                `Deliver Package ${actionLabelTextAppend}`;

            self.DELIVER_PACKAGE_SELECT_PARTNERS_ACTION.disabled = !allPackagesCanBeDelivered;
            return !allPackagesCanBeDelivered;
        });
    };

    var hasExportMetadataPermissions = function (pkg) {
        if (self.selectedPackages.length > 0) {
            return PermissionsService.canWritePackage('CLIP_ACTION_EXPORT_METADATA_VIEW_STATE', pkg.id);
        }
    };

    var metadataReportCanBeGenerated = function (reportPermissions) {
        var hasMetadataReportPermissions = reportPermissions.length > 0;
        return $q.all(reportPermissions).then(function (metadataReportPermissions) {
            _.forEach(metadataReportPermissions, function (metadataReportPermission){
                hasMetadataReportPermissions = hasMetadataReportPermissions && metadataReportPermission;
            });
            self.EXPORT_METADATA_REPORT_ACTION.disabled = !hasMetadataReportPermissions;
            return !hasMetadataReportPermissions;
        });
    };

    var hasDeliveryReportPermissions = function (pkg) {
        if(self.selectedPackages.length > 0) {
            return PermissionsService.canWritePackage('CLIP_ACTION_GENERATE_DELIVERY_REPORT_VIEW_STATE', pkg.id);
        }
    };

    var deliveryReportCanBeGenerated = function (reportPermissions) {
        var hasDeliveryReportPermissions = reportPermissions.length > 0;
        return $q.all(reportPermissions).then(function (deliveryReportPermissions) {
            _.forEach(deliveryReportPermissions, function (deliveryReportPermission) {
                hasDeliveryReportPermissions = hasDeliveryReportPermissions && deliveryReportPermission;
            });
            self.DELIVERY_REPORT_ACTION.disabled = !hasDeliveryReportPermissions;
            return !hasDeliveryReportPermissions;
        });
    };

    var canModifyPkgMetadata = function (pkg, editView) {
        if (!PackageUtilService.statusAllowsEdit(pkg.status) || pkg.isDelivering) {
            return $q.when(false);
        }
        return PermissionsService.canWritePackage(editView === 'notClip' ? 'PACKAGE_BATCH_MODIFY_METADATA_VIEW_STATE' : 'CLIP_ACTION_BATCH_MODIFY_METADATA_VIEW_STATE', pkg.id);
    };

    var allPackagesCanModifyMetadata = function (modifyMetdataPermissions) {
        var allPackagesCanModifyMetadata = modifyMetdataPermissions.length > 0;
        return $q.all(modifyMetdataPermissions).then(function (pkgCanModifyMetadata) {
            _.forEach(pkgCanModifyMetadata, function (canModify) {
                allPackagesCanModifyMetadata = allPackagesCanModifyMetadata && canModify;
            });
            self.BATCH_MODIFY_METADATA_ACTION.disabled = !allPackagesCanModifyMetadata;
            return !allPackagesCanModifyMetadata;
        });
    };

    var canRetrieveMasterMedia = function (pkg, editView) {
        if(editView === 'notClip') {
            if (parseInt(pkg.mediaCount) > 0 && !pkg.isDelivering) {
                return PermissionsService.canWritePackage('PACKAGE_RESTORE_MASTER_MEDIA_VIEW_STATE', pkg.id).then(function (hasPermission) {
                    return $q.when(hasPermission);
                });
            } else {
                return $q.when(false);
            }
        } else if (editView === 'clip') {
            if (pkg.primaryVideo && pkg.primaryImage && !pkg.isDelivering) {
                return PermissionsService.canWritePackage('CLIP_ACTION_RETRIEVE_MASTER_MEDIA_VIEW_STATE', pkg.id).then(function (hasPermission) {
                    return $q.when(hasPermission);
                });
            } else {
                return $q.when(false);
            }
        }
    };

    var allPackagesCanRetrieveMedia = function (retrieveMediaPermissions) {
        var allPackagesCanRetrieveMedia = self.selectedPackages.length > 0;
        return $q.all(retrieveMediaPermissions).then(function (pkgCanRetrieveMedia) {
            _.forEach(pkgCanRetrieveMedia, function (canRetrieve) {
                allPackagesCanRetrieveMedia = allPackagesCanRetrieveMedia && canRetrieve;
            });
            self.RETRIEVE_MASTER_MEDIA_ACTION.disabled = !allPackagesCanRetrieveMedia;
            return !allPackagesCanRetrieveMedia;
        });
    };

    var enableClipActions = function () {
        var hasSelectedClips = self.selectedPackages.length > 0;

        self.VALIDATE_PACKAGE_ACTION.disabled = !hasSelectedClips;
        self.RESET_PACKAGE_ACTION.disabled = !hasSelectedClips;
        var allValidated = allClipsCanBeValidated(self.clipPermissions.validatePermissions);
        var allDelivered = allPackagesCanBeDelivered(self.clipPermissions.deliverClipPermissions);
        var allMedia = allPackagesCanRetrieveMedia(self.clipPermissions.retrieveClipMediaPermission);
        var allModifyMetadata = allPackagesCanModifyMetadata(self.clipPermissions.clipBatchModifyPermission);
        var allMetadataReport = metadataReportCanBeGenerated(self.clipPermissions.clipMetadataReportPermission);
        var allReset = allClipsCanBeReset(self.clipPermissions.clipResetPermissions);
        var allDeliveryReport = deliveryReportCanBeGenerated(self.clipPermissions.clipDeliveryReportPermission);

        return $q.all([allValidated, allDelivered, allMedia, allModifyMetadata, allMetadataReport, allReset, allDeliveryReport]);
    };

    var packageCanBeDelivered = function (pkg, isEditView, editView) {
        if (!PackageUtilService.packageCanBeDelivered(pkg) || pkg.isDelivering) {
            return $q.when(false);
        } else {
            if (editView === 'notClip') {
                return PermissionsService.canWritePackage((isEditView) ? 'PACKAGE_DELIVER_VIEW_STATE' : 'PACKAGE_MANAGER_DELIVER_VIEW_STATE', pkg.id);
            }
            else if (editView === 'clip') {
                return PermissionsService.canWritePackage('CLIP_ACTION_DELIVER_VIEW_STATE', pkg.id);
            }
        }
    };

    var canRemovePackageMedia = function () {
        // disabled by default
        self.REMOVE_PACKAGE_MEDIA_ACTION.disabled = true;

        let mediaTabActive = $route.current.params.editView === 'media';
        let singlePackageSelected = _.size(self.selectedPackages) === 1;

        if (mediaTabActive && singlePackageSelected) {
            let pkg = _.first(self.selectedPackages);
            PermissionsService.canWritePackage('PACKAGE_MEDIA_VIEW_STATE', pkg.id).then((canWrite) => {
                let packageStatus = _.get(pkg, 'status', null);
                let statusAllowsEdit = PackageUtilService.statusAllowsEdit(packageStatus);
                let packageIsLocked = _.get(pkg, 'locked');
                let packageIsDelivering = _.get(pkg, 'isDelivering');

                let packageMediaRemovalIsAllowed = (
                    canWrite &&
                    packageStatus !== null &&
                    statusAllowsEdit &&
                    !packageIsLocked &&
                    !packageIsDelivering
                );

                self.REMOVE_PACKAGE_MEDIA_ACTION.disabled = !packageMediaRemovalIsAllowed;
            });
        }
    };

    let canDownloadPackageProxies = () => {
        self.DOWNLOAD_PROXIES_ACTION.disabled = false;

        // get proxy download permissions for each package
        let packagePermissionPromises = {};
        _.forEach(self.selectedPackages, (packageObject) => {
            packagePermissionPromises[packageObject.id] = PermissionsService.getPackagePermissions(
                'PACKAGE_VIEW_DOWNLOAD_PROXY_VIEW_STATE', packageObject.id);
        });

        $q.all(packagePermissionPromises).then((packagePermissionData) => {
            // determine whether proxies exist for each package
            let canDownloadAllProxies = true;
            _.forEach(self.selectedPackages, (packageObject) => {
                canDownloadAllProxies = canDownloadAllProxies &&
                    _.has(packageObject, 'primaryVideo.proxyId') &&
                    PermissionsService.hasWritePermission(
                        _.get(packagePermissionData[packageObject.id], '[0].permission'));
            });

            self.DOWNLOAD_PROXIES_ACTION.disabled = !canDownloadAllProxies;
        });
    };

    var checkPackagesToEnableActions = function (isEditView) {
        var hasSelectedPackages = self.selectedPackages.length > 0;
        var allPackagesCanBeReset = hasSelectedPackages && PermissionsService.isAdmin();
        var deliveryPermissions = [], modifyMetadataPermissions = [], retrieveMediaPermissions = [];
        _.forEach(self.selectedPackages, function (packageObj) {
            deliveryPermissions.push(packageCanBeDelivered(packageObj, isEditView, 'notClip'));
            modifyMetadataPermissions.push(canModifyPkgMetadata(packageObj, 'notClip'));
            retrieveMediaPermissions.push(canRetrieveMasterMedia(packageObj, 'notClip'));
            allPackagesCanBeReset = allPackagesCanBeReset && PackageUtilService.statusAllowsReset(packageObj.status);
        });
        self.VALIDATE_PACKAGE_ACTION.disabled = !hasSelectedPackages;
        self.RESET_PACKAGE_ACTION.disabled = !allPackagesCanBeReset;
        var allDelivered = allPackagesCanBeDelivered(deliveryPermissions);
        var allMetadata = allPackagesCanModifyMetadata(modifyMetadataPermissions);
        var allMedia = allPackagesCanRetrieveMedia(retrieveMediaPermissions);
        return $q.all([allDelivered, allMetadata, allMedia, canRemovePackageMedia(), canDownloadPackageProxies()]);
    };

    self.checkClipPackagesToEnableActions = function () {
        self.clipPermissions.validatePermissions = [];
        self.clipPermissions.clipResetPermissions = [];
        self.clipPermissions.deliverClipPermissions = [];
        self.clipPermissions.retrieveClipMediaPermission = [];
        self.clipPermissions.clipBatchModifyPermission = [];
        self.clipPermissions.clipMetadataReportPermission = [];
        self.clipPermissions.clipDeliveryReportPermission = [];

        _.forEach(self.selectedPackages, function (packageObj) {
            self.clipPermissions.hasPermissions = true;
            self.clipPermissions.validatePermissions.push(canValidateClip(packageObj));
            self.clipPermissions.clipResetPermissions.push(canResetClip(packageObj));
            self.clipPermissions.deliverClipPermissions.push(packageCanBeDelivered(packageObj, true, 'clip'));
            self.clipPermissions.retrieveClipMediaPermission.push(canRetrieveMasterMedia(packageObj, 'clip'));
            self.clipPermissions.clipBatchModifyPermission.push(canModifyPkgMetadata(packageObj, 'clip'));
            self.clipPermissions.clipMetadataReportPermission.push(hasExportMetadataPermissions(packageObj));
            self.clipPermissions.clipDeliveryReportPermission.push(hasDeliveryReportPermissions(packageObj));
        });

        return enableClipActions();
    };

    self.handleGridItemSelection = function () {
        self.actionsLoading = true;
        resetActionsToDisabled();
        checkPackagesToEnableActions().then(function () {
            self.actionsLoading = false;
        });
    };

    self.handleEditView = function (editView) {
        if (editView === 'notClip') {
            // Package Manager
            self.actionsLoading = true;
            resetActionsToDisabled();
            checkPackagesToEnableActions(true).then(function () {
                self.actionsLoading = false;
            });
        } else if(editView === 'clip') {
            // Clipper Tab
            resetClipActionsToDisabled();

            if (self.clipPermissions.hasPermissions) {
                enableClipActions();
            }
        }
    };
});
